import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDtp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.0465 12.7271L19.5918 16.7273L14.3192 15.8185L12.5007 20L10.3188 15.8185L5.40958 16.7273L7.95488 12.7271L4.5 10.5454L8.31829 9.09107L7.0453 4L12.5 7.27268L17.9547 4L16.6817 9.09107L20.5 10.5454L17.0451 12.7271H17.0465Z",
		fill: "#141218"
	})
});
export default SvgDtp;
